import { Controller } from "@hotwired/stimulus"

// Opens the View Email modal for a Win Back campaign: points the modal's
// iframe at the campaign's preview endpoint (the real mailer render,
// sandboxed in an iframe so email CSS can't leak into the app), swaps the
// "sample only" notice's code shape to the campaign's prefix, and shows the
// shared gl-modal.
export default class extends Controller {
  static targets = ["frame", "title", "modal", "codeShape"]

  open(event) {
    const { url, title, codeShape } = event.params
    if (this.hasTitleTarget && title) this.titleTarget.textContent = title
    if (this.hasCodeShapeTarget && codeShape) this.codeShapeTarget.textContent = codeShape
    if (this.hasFrameTarget) this.frameTarget.src = url

    if (!this.hasModalTarget) return
    const modal = window.bootstrap?.Modal?.getOrCreateInstance(this.modalTarget)
    if (modal) modal.show()
  }

  // Blank the iframe on hide so the previous campaign's email never flashes
  // when a different View Email button opens the modal next.
  clear() {
    if (this.hasFrameTarget) this.frameTarget.src = "about:blank"
  }
}
